<template>
    <v-container fluid class="desarrollo-root">
        <div class="desarrollo-card">
            <div class="icon-wrapper">
                <v-icon size="82" color="#f7c325">mdi-tools</v-icon>
            </div>

            <h1>{{ titulo }}</h1>

            <p>
                Este módulo se encuentra actualmente en construcción.
                <br />
                Pronto estará disponible para su uso.
            </p>

            <v-chip color="#5e672c" text-color="white" class="mt-4">
                <v-icon left small>mdi-progress-wrench</v-icon>
                En desarrollo
            </v-chip>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'EnDesarrollo',
    props: {
        titulo: {
            type: String,
            default: 'Módulo en construcción'
        }
    }
};
</script>

<style scoped>
.desarrollo-root {
    min-height: calc(100vh - 80px);
    background:
        radial-gradient(circle at top right, rgba(201, 165, 56, 0.16), transparent 28%),
        linear-gradient(180deg, #f7f8f3 0%, #eef0ea 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 32px;
}

.desarrollo-card {
    width: min(100%, 720px);
    background: #ffffff;
    border: 1px solid rgba(108, 117, 51, 0.16);
    border-radius: 26px;
    box-shadow: 0 18px 44px rgba(59, 71, 33, 0.12);
    padding: 56px 36px;
    text-align: center;
}

.icon-wrapper {
    width: 132px;
    height: 132px;
    margin: 0 auto 24px;
    border-radius: 50%;
    background: rgba(247, 195, 37, 0.14);
    border: 1px solid rgba(247, 195, 37, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
}

h1 {
    color: #384018;
    font-size: 34px;
    font-weight: 900;
    margin-bottom: 14px;
    text-transform: uppercase;
}

p {
    color: #6b7280;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.6;
    margin: 0;
}

@media (max-width: 600px) {
    .desarrollo-card {
        padding: 36px 22px;
    }

    h1 {
        font-size: 24px;
    }

    p {
        font-size: 15px;
    }
}
</style>